import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as api from "../../common/manipurCommon/API";
import * as func from "../../common/manipurCommon/FunctionCalls";
import Utils from "../../common/manipurCommon/Utils";
import Select from "react-select";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";

const Screening = () => {

    const testTypeList = [{ typeId: "1", typeName: "Functional Movement Screen" }, { typeId: "2", typeName: "Y-Balance test" }, { typeId: "3", typeName: "Hop tests" }, { typeId: "4", typeName: "Strength testing" }, { typeId: "5", typeName: "ROM measurements" }, { typeId: "6", typeName: "Cardio fitness tests" }, { typeId: "7", typeName: "Sport-specific assessments" }];
    const outcomeList = [{ outcomeId: "1", outComeName: "Pass" }, { outcomeId: "2", outComeName: "Fail" }]

    const [centerId, setCenterId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [screeningId, setScreeningId] = useState("");
    const [dateOfScreening, setDateOfScreening] = useState("");
    const [testType, setTestType] = useState("");
    const [outCome, setOutCome] = useState("");
    const [score, setScore] = useState("");
    const [notes, setNotes] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [status, setStatus] = useState("");
    const [centerList, setCenterList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [screeningList, setScreeningList] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showTable, setShowTable] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        async function fetchCenters() {
            setIsLoading(true);
            // const centersResponse = await func.listGeoCenters();
            // setCenterList(Array.isArray(centersResponse) ? centersResponse : [])
            const response = await func.listActiveAthletes();
            setAthleteList(Array.isArray(response) ? response : [])
            setIsLoading(false);
        }
        fetchCenters();
    }, [])

    const filteredData = screeningList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.dateofScreening)}</span>
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const testTypeRender = (rowData) => {
        return <span>{rowData.testTypeName}</span>
    };

    const noteRender = (rowData) => {
        return <span>{rowData.note}</span>
    };

    const scoreRender = (rowData) => {
        return <span>{rowData.score}</span>
    };

    const outcomeRender = (rowData) => {
        return <span>{(rowData.outcome == 1) ? "Pass" : "Fail"}</span>
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editScreening(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const injId = rowData.screeningId;
        return (
            <Link to="#" onClick={() => deleteScreening(injId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newScreening() {
        setOpenModal(true)
        setIsEdit(false)
        setCenterId("");
        setAthleteId("");
        setDateOfScreening("");
        setTestType("");
        setOutCome("");
        setScore("");
        setNotes("");
    }

    async function editScreening(rowData) {
        setAthleteId(rowData.athleteId);
        setDateOfScreening(rowData.dateofScreening)
        setTestType(rowData.testType)
        setOutCome(rowData.outcome)
        setScore(rowData.score)
        setNotes(rowData.note)
        setScreeningId(rowData.screeningId)
        setStatus(rowData.status)
        setIsEdit(true)
        setOpenModal(true)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateScreening();
            } else {
                const formData = new FormData();
                // formData.append("centerId", centerId);
                formData.append("athleteId", athleteId);
                formData.append("dateofScreening", dateOfScreening);
                formData.append("testType", testType);
                formData.append("outcome", outCome);
                formData.append("score", score);
                formData.append("note", notes);
                const createScreening = api.Screening;
                fetch(createScreening, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    window.location.reload(); // 🔁 Reload only after OK is clicked
                                }
                            });
                        }
                    })
            }
        }
    }

    function updateScreening() {
        const formData = new FormData();
        // formData.append("centerId", centerId);
        formData.append("athleteId", athleteId);
        formData.append("dateofScreening", dateOfScreening);
        formData.append("testType", testType);
        formData.append("outcome", outCome);
        formData.append("score", score);
        formData.append("note", notes);
        const updateScreening = api.Screening + "/" + screeningId;
        fetch(updateScreening, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteScreening() {
        const deleteScreening = api.Screening + "/" + 0;
        fetch(deleteScreening, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    return (
        <>
            {
                isLoading && (
                    <div id="global-loader">
                        <div className="loader-img">
                            <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                        </div>
                    </div>
                )
            }
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Screening</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newScreening() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Injury Diagnosis">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="row">
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">List Screenings for</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                    const screeningResponse = await func.listScreening(e.value);
                                                    setScreeningList(Array.isArray(screeningResponse) ? screeningResponse : []);
                                                    setShowTable(true)
                                                }}
                                                // styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                {showTable && (
                                    <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                )}
                            </div>
                            {showTable && (
                                <div className="tab-content">
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="athleteName"
                                                    header="Athlete"
                                                    body={athleteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="dateofScreening"
                                                    header="Date Of Screening"
                                                    body={dateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="testType"
                                                    header="Test Type"
                                                    body={testTypeRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="score"
                                                    header="Score"
                                                    body={scoreRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="outcome"
                                                    header="Outcome"
                                                    body={outcomeRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="note"
                                                    header="Notes"
                                                    body={noteRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="status"
                                                    header="Status"
                                                    body={statusRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                {currentPermissions.includes("edit") ?
                                                    <Column
                                                        className="text-link"
                                                        body={editDetails}
                                                    ></Column>
                                                    : null
                                                }
                                                {currentPermissions.includes("delete") ?
                                                    <Column
                                                        className="text-link"
                                                        body={deleteDetails}
                                                    ></Column>
                                                    : null
                                                }
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                show={openModal}
                centered
                size="xl">
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Screening</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            {!isEdit && (
                                <>
                                    {/* <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Center</label>
                                            <Select
                                                value={centerList.find(cntr => cntr.geoCenterId === centerId) ? {
                                                    value: centerId,
                                                    label: centerList.find(cntr => cntr.geoCenterId === centerId).geoCenterName
                                                } : null}
                                                onChange={async (e) => {
                                                    setCenterId(e.value);
                                                    const response = await func.listCenterActiveAthletes(e.value);
                                                    setAthleteList(Array.isArray(response) ? response : [])
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Center"
                                                options={centerList.map(cntr => ({
                                                    value: cntr.geoCenterId,
                                                    label: cntr.geoCenterName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div> */}
                                    <div className="col-lg-3 mb-10">
                                        <div className="input-space">
                                            <label className="form-label">Athlete</label>
                                            <Select
                                                value={athleteList.find(athlt => athlt.userId === athleteId) ? {
                                                    value: athleteId,
                                                    label: athleteList.find(athlt => athlt.userId === athleteId).athleteName
                                                } : null}
                                                onChange={async (e) => {
                                                    setAthleteId(e.value);
                                                }}
                                                styles={customSelect}
                                                required
                                                placeholder="Select Athlete"
                                                options={athleteList.map(athlt => ({
                                                    value: athlt.userId,
                                                    label: athlt.athleteName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Date Of Screening</label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        required
                                        name="dateofScreening"
                                        value={dateOfScreening}
                                        onChange={(e) => { setDateOfScreening(e.target.value) }}
                                        placeholder="Enter Date of Diagnosis" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Test Type</label>
                                    <Select
                                        value={testTypeList.find(test => test.typeId === testType) ? {
                                            value: testType,
                                            label: testTypeList.find(test => test.typeId === testType).typeName
                                        } : null}
                                        onChange={async (e) => {
                                            setTestType(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Test Type"
                                        options={testTypeList.map(test => ({
                                            value: test.typeId,
                                            label: test.typeName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Outcome</label>
                                    <Select
                                        value={outcomeList.find(out => out.outcomeId === outCome) ? {
                                            value: outCome,
                                            label: outcomeList.find(out => out.outcomeId === outCome).outComeName
                                        } : null}
                                        onChange={async (e) => {
                                            setOutCome(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        placeholder="Select Outcome"
                                        options={outcomeList.map(out => ({
                                            value: out.outcomeId,
                                            label: out.outComeName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Score</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="score"
                                        value={score}
                                        onChange={(e) => { setScore(e.target.value) }}
                                        placeholder="Enter Score" />
                                </div>
                            </div>
                            <div className="col-lg-3 mb-10">
                                <div className="input-space">
                                    <label className="form-label">Physiotherapist Notes</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="notes"
                                        value={notes}
                                        onChange={(e) => { setNotes(e.target.value) }}
                                        placeholder="Enter Notes" />
                                </div>
                            </div>
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />{isEdit ? "Update " : "Save "}</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default Screening;